import { getIpLocation, HttpRequestError } from '@digiwedge/teetime-api-client';
import { getFallbackLocation } from './getFallbackLocation.js';
/**
 * Look up approximate coordinates via the Tee Time backend `/api/ip-location`.
 */
export async function getGeoIpLocation(signal) {
    try {
        const result = (await getIpLocation(signal));
        const { latitude, longitude } = result ?? {};
        if (typeof latitude !== 'number' || typeof longitude !== 'number') {
            throw new Error('GeoIP lookup returned invalid shape');
        }
        return { latitude, longitude, origin: 'geoip' };
    }
    catch (err) {
        const name = err?.name;
        const isAborted = name === 'AbortError' || signal?.aborted === true;
        if (isAborted) {
            throw err instanceof Error ? err : new Error(String(err));
        }
        // Safe check for HttpRequestError - avoid instanceof crash when mocked
        const isHttpRequestError = typeof HttpRequestError === 'function' &&
            err instanceof HttpRequestError;
        if (isHttpRequestError) {
            const e = err;
            console.warn('GeoIP lookup failed; using fallback location', {
                status: e.status,
                statusText: e.statusText,
                url: e.url,
                body: e.bodyJson ?? e.bodyText,
                headers: e.headers,
            });
        }
        else {
            console.warn('GeoIP lookup failed; using fallback location', err);
        }
        return getFallbackLocation();
    }
}
//# sourceMappingURL=getGeoIpLocation.js.map